import { useSelector } from 'react-redux';
import type { AppLoadedPayload } from '@/store/interfaces';

export const useSelectGroup = () => {
  const group = useSelector((state: AppLoadedPayload) => state.group);

  return group;
};